import styled from 'styled-components';

export enum ETickBtnType {
  white,
  red,
}

interface ITicketingButton {
  text: string;
  type?: ETickBtnType;
}

const MainWrap = styled.button<any>`
  color: ${(p) => (p.type == ETickBtnType.red ? 'white' : '#EA475C')};
  background-color: ${(p) => (p.type == ETickBtnType.red ? '#EA475C' : 'white')};
  border: ${(p) => (p.type == ETickBtnType.red ? 'none' : '2px solid #EA475C')};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
  padding: 16px 30px;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: initial;

  &:active {
    ${(p) =>
      p.type == ETickBtnType.red ? 'opacity:0.8;' : 'background-color:rgba(234,71,92,0.2);'}
  }

  &:focus {
    ${(p) => (p.type == ETickBtnType.red ? '' : 'border:2px solid #EA475C;')}
  }
`;

const TicketingButton = (props: ITicketingButton) => {
  const { text, type = ETickBtnType.red } = props;
  return <MainWrap type={type}>{text}</MainWrap>;
};

export default TicketingButton;
